import styled, { keyframes, css } from "styled-components";

const pulse = keyframes`
	0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
	}

	15% {
		transform: scale(1);
		box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
	}

	30% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
  
	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
	}
`;

const Button = styled.button<{
  animated?: boolean;
  disabled?: boolean;
  isDark?: boolean;
  isSmall?: boolean;
  isBig?: boolean;
}>`
  padding: ${({ isSmall, isBig }) => {
    if (isSmall) {
      return `0.2em 0.3em`;
    }
    if (isBig) {
      return `1.5em 2em`;
    }

    return `1em 1.4em`;
  }};
  font-size: ${({ isSmall, isBig }) => {
    if (isSmall) {
      return `0.6rem`;
    }
    if (isBig) {
      return `1.5rem`;
    }

    return `1rem`;
  }};
  border-radius: 0.2em;
  font-weight: 700;
  text-transform: lowercase;
  font-family: inherit;
  background: white;
  border: 0px;
  border-bottom: 0.2em solid #80805c;
  cursor: pointer;

  &:hover {
    background: #80805c;
    color: white;
    border-bottom-color: black;
  }

  ${({ isDark }) =>
    isDark &&
    css`
      background: #80805c;
      color: white;
      border-bottom-color: black;

      &:hover {
        background: white;
        color: black;
        border-bottom-color: black;
      }
    `}

  ${({ animated }) =>
    animated &&
    css`
      animation: ${pulse} 2s linear infinite;
    `}

  ${({ disabled }) => disabled && `opacity: 0.5; cursor-events: none;`}
`;

export default Button;
